module.exports = function () {
    if ($('.event-detail').length) {

        $('.event-detail__header__register-button').click(function () {
            var top = $($(this).attr('href')).offset().top - 32;
            $('html,body').animate({ scrollTop: top + 'px' });
            return false;
        });

        var doResize = function () {
            if (window.innerWidth >= 768) {
                var formTop = $('.event-detail-form').length ? $('.event-detail-form').position().top : 0;
                $('.event-detail-body').css('min-height',
                    ($('.event-detail-form').outerHeight() + formTop - $('.event-detail__header').height() + 48) +
                    'px');
            }
            else {
                $('.event-detail-body').css('min-height', '');
            }


            $('.event-detail-related-article-content').css('min-height', $('.event-detail-related-article-content').children('img').outerHeight() + 'px');
        }

        if ($('.event-detail--with-form').length) {
            doResize();
            setTimeout(doResize, 100);
            $(window).resize(doResize);
        }
        
        $('.event-detail-related-event-share').on('click', function (e) {
            $(this).toggleClass('hover');
            e.stopPropagation();
            e.preventDefault();
            return false;            
        });

        $('.event-detail-related-event-share').hover(function () {
            $(this).addClass('hover');
        }, function () {
            $(this).removeClass('hover');
        });
    }
};